// @flow

import React from 'react';

import { base } from 'app/developer-v3/components/PartnerSupportForm/utils/tree';

import type { NodeDefinition } from 'app/developer-v3/components/PartnerSupportForm/utils/tree/types';

import Radio from './Radio';
import { type NodeOptions } from './types';

const radio = (options: NodeOptions): NodeDefinition => {
  const children = {};
  const items = [];

  options.items.forEach(({ child, ...item }) => {
    if (item.value in children) {
      throw new Error(
        `Each item should have an unique ID. Found dupe: ${item.value}.`
      );
    }

    items.push(item);
    children[item.value] = child;
  });

  const node = base({
    id: options.id,
    children,
    isDataValid: data => {
      return !!node.getNextNode(data, {});
    },
    getNextNode: data => {
      return typeof data === 'string' ? node.children[data] : null;
    },
    render: props => {
      return <Radio {...props} items={items} label={options.label} />;
    },
    export: data => {
      const item = items.find(({ value }) => value === data);
      return {
        id: node.id,
        data,
        label: options.label,
        zendeskCustomFieldId: options.zendeskCustomFieldId,
        zendeskCustomFieldValue:
          data &&
          (items.find(({ value }) => value === data) || {})
            .zendeskCustomFieldValue,
        formatted: item && item.label,
      };
    },
  });

  return node;
};

export default radio;
